import { ArrowLeft } from "lucide-react";

export const BackOsom = ({ testId = "back-osom", className = "" }) => (
  <a
    href="https://objectifscopoutremer.com"
    rel="noopener"
    data-testid={testId}
    aria-label="Retour au site OBJECTIF SCOP OUTREMER"
    className={`group inline-flex items-center gap-3 text-[13px] font-extrabold tracking-[0.16em] text-[#17352e] hover:text-[#ae833a] transition-colors ${className}`}
  >
    <span className="inline-flex h-[34px] w-[34px] items-center justify-center rounded-full border-[1.5px] border-[#ae833a] text-[#ae833a] transition-[background-color,color,transform] group-hover:bg-[#ae833a] group-hover:text-white group-hover:-translate-x-0.5">
      <ArrowLeft className="h-4 w-4" />
    </span>
    OBJECTIFSCOPOUTREMER.COM
  </a>
);
